import moment from 'moment-timezone';
import { inject } from '../utils';
import { fetchTranslations, getLanguage, handleLanguageChange } from '../state/actions/locale';

class TranslationService {
  constructor(store) {
    this.store = store;
    moment.locale('en');
  }

  /**
   * Handles fetching of language from preferences
   */
  handleTranslations(props) {
    const lang = getLanguage();
    const isAvailable = !(lang === 'en' || props.translations[lang]);
    if (isAvailable) {
      this.store.dispatch(fetchTranslations(lang, false, props.setTranslations, props.setLanguage));
    } else {
      handleLanguageChange(lang);
      props.setLanguage(lang);
    }
  }
}

inject(TranslationService, ['Store']);
export default TranslationService;



// WEBPACK FOOTER //
// ./src/i18n/TranslationService.js